export const ACTION_TYPE = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
};

export const STAGE = {
  PROMPT: 'prompt',
  PROCESSING: 'processing',
  REVIEW: 'review',
  SUCCESS: 'success',
};

export const CONFIRMATION_ACTION = {
  REJECT: 'reject',
  APPROVE: 'approve',
};

export const PROCESSING_MESSAGES = [
  "Analyzing your prompt and generating variant details...",
  "Thinking through your request, please hold on...",
  "Generating variants based on your instructions...",
  "Letting the AI elves work their magic...",
  "Hang tight! Cooking up your product variants...",
  "Reviewing and preparing your variant suggestions...",
  "Crunching data to match your requirements..."
];